<script lang="ts">
	export let text = "";
	export let active = false;

</script>

<button on:click class:active> {text} </button>

<style lang="scss">
	@import "../variables.scss";

	button {
		display: flex;
		align-items: center;
		justify-content: center;

		box-sizing: border-box;
		padding: 6px 10px;
		height: 32px;
		color: var(--grey5);
		border-radius: 999px;
		border: 1px solid #bcbfc3;
		background-color: transparent;
		&.active {
			background-color: var(--grey5);
			color: white;
			font-weight: 500;
			border: none;
			padding-top: 4px;
		}

		&:hover {
			cursor: pointer;
		}
	}

	@include DesktopSize {
		button {
			padding: 10px 20px;
			font-size: 1.25rem;
			height: 40px;
			&.active {
				padding-top: 8px;
			}
		}
	}

</style>
